import { IconWrapper } from '../runtime';
export default IconWrapper('video-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'e6a3d51b' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M15.6718 12L9.37512 8.44689L9.37512 15.5531L15.6718 12ZM18.5138 12.9798C19.2766 12.5493 19.2766 11.4507 18.5138 11.0202L8.80299 5.54055C8.05304 5.11736 7.12512 5.65921 7.12512 6.52032L7.12512 17.4797C7.12512 18.3408 8.05304 18.8826 8.80299 18.4594L18.5138 12.9798Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'e6a3d51b',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});